<template>
  <div class="create-reward-wrapper">
    <Menu v-if="!activeSection.isCreateReward" :activeSection="activeSection" @goBackToComponent="goBackToComponent"></Menu>
    <transition name="fade">
      <div v-if="activeSection.isCreateReward">
        <h1 v-if="rewardKey">Edit Reward</h1><h1 v-else>New Reward</h1>
        <el-input class="new-rule" placeholder="Name of the reward" v-model="rewardInfo.name" clearable></el-input>
        <div class="select-type">
          <h2 class="title">Select type</h2>
          <label class="field" :class="[rewardInfo.kind === 'MedalByRank' ? 'active' : '']">
            <h3 class="type-heading left-part">Medal by Rank</h3>
            <span class="right-part medal">
              <img src="@/assets/imgs/medal.svg">
            </span>
            <input type="radio" name="MedalByRank" id="MedalByRank" value="MedalByRank" v-model="rewardInfo.kind">
          </label>
          <label class="field" :class="[rewardInfo.kind === 'ChipsByRank' ? 'active' : '']">
            <h3 class="type-heading left-part">Chips by Rank</h3>
            <span class="right-part">
              <img src="@/assets/imgs/chips-icon.svg">
            </span>
            <input type="radio" name="ChipsByRank" id="ChipsByRank" value="ChipsByRank" v-model="rewardInfo.kind">
          </label>
          <label class="field" :class="[rewardInfo.kind === 'ChipsByPoint' ? 'active' : '']">
            <h3 class="type-heading left-part">Chips by Points</h3>
            <span class="right-part">
              <img src="@/assets/imgs/chips-icon.svg">
            </span>
            <input type="radio" name="ChipsByPoint" id="ChipsByPoint" value="ChipsByPoint" v-model="rewardInfo.kind">
          </label>
        </div>
          <button class="confirm-btn" @click="showMedalInfo()">Continue
          </button>
      </div>
    </transition>
    <transition name="fade">
      <div class="content-inner-wrapper" v-if="activeSection.isMedalByRank && rewardInfo.kind == 'MedalByRank'">
      <h1>Medal by Rank</h1>
      <div class="contest-box" v-for="(medal, index) in medalArr" :key="index">
        <div class="contest-box-inner">
          <h3>Rank name</h3>
          <div class="rule-box">
            <div>
              <el-input placeholder="Gold" v-model="medal.name" clearable></el-input><span class="extra-label" :class="medal.name ? '' : 'empty'"><img src="@/assets/imgs/medal.svg"></span>
            </div>
          </div>
          <h3>Rank range</h3>
          <div class="rule-box num-players">
            <label class="field numbers" :class="[parseInt(player) === parseInt(medal.range) ? 'active' : '']"   v-for="player in maxPlayersTeam" :key="player">
              <h3 v-if="index > 0 && medalArr[index - 1] && medalArr[index - 1]['range']" :class="parseInt(player) > medalArr[index - 1]['range'] ? 'show' : 'hide'" class="min-players numbers">{{player}}</h3>
              <h3 v-else class="min-players numbers">{{player}}</h3>
              <input type="radio" name="default" :value="player" v-model="medal.range">
            </label>
          </div>
        </div>
      </div>

      <div class="contest-box">
        <div class="contest-box-inner">
          <span class="add-icon"><img src="@/assets/imgs/add-icon.svg"></span>
          <span class="create-new-rule" @click="AddNewRank">ADD NEW RANK RANGE</span>
        </div>
      </div>

      <div class="contest-box">
        <div class="contest-box-inner">
          <h3>Default participants chips</h3>
          <div class="rule-box">
            <div>
              <el-input type="number" min=0 oninput="validity.valid||(value='');" placeholder="0" v-model="rewardInfo.default_participants_chips" clearable></el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="content-box">
        <div class="img-box">
          <img src="@/assets/imgs/description.svg">
        </div>
        <div class="content">
          <h5>Notes</h5>
          <p v-if="rewardInfo.desc">{{rewardInfo.desc}}</p>
          <p v-else>Add notes about the rule this will be visible in the contest.</p>
          <p>
            <button class="add-link" v-if="rewardInfo.desc" @click="showNotes = true">Edit</button>
            <button class="add-link" v-else @click="showNotes = true">Add</button>
            <AddTextPopup @onClose="onClose" :property="'desc'" :payload="rewardInfo" :show="showNotes"></AddTextPopup>
          </p>
        </div>
      </div>

      <button class="create-btn" @click="saveReward()">Create Reward
      </button>
    </div>
    </transition>
    <transition name="fade">
      <div class="content-inner-wrapper" v-if="activeSection.isChipsByRank && rewardInfo.kind == 'ChipsByRank'">
      <h1>Chips by Rank</h1>
      <div class="contest-box" v-for="(medal, index) in medalArr" :key="index">
        <div class="contest-box-inner">
          <h3>Chips</h3>
          <div class="rule-box">
            <div>
              <el-input type="number" min=0 oninput="validity.valid||(value='');" placeholder="100" v-model="medal.name" clearable></el-input><span class="extra-label" :class="medal.name ? '' : 'empty'"><img src="@/assets/imgs/chips-icon.svg"></span>
            </div>
          </div>
          <h3>Rank range</h3>
          <div class="rule-box num-players">
            <label class="field numbers" :class="[parseInt(player) === parseInt(medal.range) ? 'active' : '']"   v-for="player in maxPlayersTeam" :key="player">
              <h3 class="min-players numbers">{{player}}</h3>
              <input type="radio" name="default" :value="player" v-model="medal.range">
            </label>
          </div>
        </div>
      </div>

      <div class="contest-box">
        <div class="contest-box-inner">
          <span class="add-icon"><img src="@/assets/imgs/add-icon.svg"></span>
          <span class="create-new-rule" @click="AddNewRank">ADD NEW RANK RANGE</span>
        </div>
      </div>
      <div class="contest-box">
        <div class="contest-box-inner">
          <h3>Default participants chips</h3>
          <div class="rule-box">
            <div>
              <el-input type="number" min=0 oninput="validity.valid||(value='');" placeholder="0" v-model="rewardInfo.default_participants_chips" clearable></el-input>
            </div>
          </div>
        </div>
      </div>

      <div class="content-box">
        <div class="img-box">
          <img src="@/assets/imgs/description.svg">
        </div>
        <div class="content">
          <h5>Notes</h5>
          <p v-if="rewardInfo.desc">{{rewardInfo.desc}}</p>
          <p v-else>Add notes about the rule this will be visible in the contest.</p>
          <p>
            <button class="add-link" v-if="rewardInfo.desc" @click="showNotes = true">Edit</button>
            <button v-else @click="showNotes = true" class="add-link">Add</button>
            <AddTextPopup @onClose="onClose" :property="'desc'" :payload="rewardInfo" :show="showNotes"></AddTextPopup>
          </p>
        </div>
      </div>

      <button class="create-btn" @click="saveReward()">Create Reward
      </button>
    </div>
    </transition>
    <transition name="fade">
      <div class="content-inner-wrapper" v-if="activeSection.isChipsByPoint && rewardInfo.kind == 'ChipsByPoint'">
        <h1>Chips by point</h1>
        <div class="contest-box">
          <div class="contest-box-inner">
            <h3>Chips per point</h3>
            <div class="rule-box">
              <div>
                <el-input type="number" min=0 oninput="validity.valid||(value='');" placeholder="100" v-model="rewardInfo.chips_per_point" clearable></el-input><span class="extra-label" :class="rewardInfo.chips_per_point ? '' : 'empty'"><img src="@/assets/imgs/chips-icon.svg"></span>
              </div>
            </div>
            <h3>Max chips</h3>
            <div class="rule-box">
              <div>
                <el-input type="number" min=0 oninput="validity.valid||(value='');" placeholder="100" v-model="rewardInfo.max_chips" clearable></el-input>
              </div>
            </div>
            <h3>Default participants chips</h3>
            <div class="rule-box">
              <div>
                <el-input type="number" min=0 oninput="validity.valid||(value='');" placeholder="0" v-model="rewardInfo.default_participants_chips" clearable></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="content-box">
          <div class="img-box">
            <img src="@/assets/imgs/description.svg">
          </div>
          <div class="content">
            <h5>Notes</h5>
            <p v-if="rewardInfo.desc">{{rewardInfo.desc}}</p>
            <p v-else>Add notes about the reward this will be visible in the contest.</p>
            <p>
              <button class="add-link" v-if="rewardInfo.desc" @click="showNotes = true">Edit</button>
              <button v-else @click="showNotes = true" class="add-link">Add</button>
              <AddTextPopup @onClose="onClose" :property="'desc'" :payload="rewardInfo" :show="showNotes"></AddTextPopup>
            </p>
          </div>
        </div>

        <button class="create-btn" @click="saveReward()"><span v-if="rewardKey">Save</span><span v-else>Create Reward</span>
        </button>
      </div>
    </transition>
  </div>
</template>
<script>
import { Enum } from '@/helpers/enum'
import { DataState, WizardManager } from '@/state'
import { Reward, Medal } from '@/models/fantasyconsole/rule'
import AddTextPopup from '@/components/fantasyconsole/AddTextPopup'

export const Step = new Enum({
  CreateReward: 'Create Reward',
  MedalByRank: 'MedalByRank',
  ChipsByRank: 'ChipsByRank',
  ChipsByPoint: 'ChipsByRank'
})

export default {
  components: {
    AddTextPopup
  },
  props: {
    rewardKey: null
  },
  data () {
    return {
      ruleManager: null,
      state: DataState.newNotInit(),
      selectReward: null,
      rewardInfo: new Reward(),
      medalInfo: new Medal(),
      newRule: null,
      sections: Step,
      activeSection: Step.CreateReward,
      minParticipants: 0,
      maxParticipants: '∞',
      maxPlayersTeam: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20'],
      showMinRoles: false,
      boostPlayers: false,
      showNotes: false,
      medalArr: [],
      page: null,
      wizardManager: {},
      contest: null
    }
  },

  created () {
    if (!this.rewardKey) {
      this.medalArr.push(new Medal())
    }
  },
  mounted () {
    this.wizardManager = JSON.parse(localStorage.getItem('wizardManager'))
    if (this.rewardKey) {
      this.onViewOpenned()
    } else {
      this.rewardInfo = new Reward()
      if (WizardManager.flow.length < 1) {
        this.getWizardmanager()
      }
    }
    this.createWizard(this.activeSection, this.wizardManager.stateData)
  },

  methods: {
    goBackToComponent (page) {
      this.activeSection = Step[page['key']]
    },
    getWizardmanager () {
      if (this.wizardManager.flow.length > 1) {
        if (this.wizardManager.ChildWizard.flow.length == 0) {
          this.createWizard(WizardManager.flow[WizardManager.flow.length - 1], this.wizardManager.stateData)
        }
        for (let section of this.wizardManager.ChildWizard.flow) {
          const found = WizardManager.ChildWizard.flow.some(e1 => e1.key === section.key)
          if (!found) {
            WizardManager.ChildWizard.flow.push(section)
          }
        }
        this.activeSection = Step[WizardManager.ChildWizard['flow'][WizardManager.ChildWizard.flow.length - 1]['key']]
        this.contest = this.wizardManager.stateData
        if (Object.keys(this.wizardManager.ChildWizard.stateData).length > 0) {
          this.rewardInfo = this.wizardManager.ChildWizard.stateData
        }
      } else {
        this.createWizard(this.activeSection, this.wizardManager.stateData)
      }
    },
    onViewOpenned () {
      Reward.getReward(this.rewardKey).then((resp) => {
        this.rewardInfo = resp
        this.medalArr = []
        if (this.rewardInfo.kind) {
          this.rewardInfo.kind = this.rewardInfo.kind.value
        }
        if (this.rewardInfo.rank_medals && this.rewardInfo.rank_medals.length > 0) {
          for (let info in this.rewardInfo.rank_medals) {
            this.medalArr.push(new Medal(this.rewardInfo.rank_medals[info], this.rewardInfo.rank_break_points[info]))
          }
        }
        else if (this.rewardInfo.rank_chips && this.rewardInfo.rank_chips.length > 0) {
          for (let info in this.rewardInfo.rank_chips) {
            this.medalArr.push(new Medal(this.rewardInfo.rank_chips[info], this.rewardInfo.rank_break_points[info]))
          }
        }
        // this.getWizardmanager()
        this.state.changeToLoaded()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },
    showMedalInfo () {
      if (this.rewardInfo.kind && this.rewardInfo.name) {
        if (this.rewardInfo.kind === 'MedalByRank') {
          this.activeSection = Step.MedalByRank
          this.createWizard(Step.MedalByRank, this.contest)
        } else if (this.rewardInfo.kind === 'ChipsByRank') {
          this.activeSection = Step.ChipsByRank
          this.createWizard(Step.ChipsByRank, this.contest)
        } else {
          this.activeSection = Step.ChipsByPoint
          this.createWizard(Step.ChipsByPoint, this.contest)
        }
      } else if (this.rewardInfo.kind == null && this.rewardInfo.name) {
        this.$notify({
          message: 'Please select type',
          type: 'warning'
        })
      } else if ((this.rewardInfo.name == null || this.rewardInfo.name == '') && this.rewardInfo.kind) {
        this.$notify({
          message: 'Reward name is missing!!',
          type: 'warning'
        })
      } else {
        this.$notify({
          message: 'Please fill the fields',
          type: 'warning'
        })
      }
    },
    AddNewRank () {
      this.medalArr.push(new Medal())
    },
    saveReward () {
      Reward.createReward(this.rewardInfo, this.medalArr).then((resp) => {
        this.$notify({
          title: 'Success',
          message: 'Reward created successfully',
          type: 'success'
        })
        this.state.changeToLoaded()
        this.$emit('rewardsaved')
      }).catch((error) => {
        this.state.changeToError(error)
        if (this.state.msg.response.data.error) {
          this.$notify({
            title: 'Error',
            message: this.state.msg.response.data.error.msg,
            type: 'error'
          })
        }
      })
    },
    onClose (payload, show) {
      this.showNotes = show
    },
    createWizard (section, payload) {
      const found = WizardManager.ChildWizard.flow.some(e1 => e1.key === section.key)
      if (!found) {
        WizardManager.ChildWizard.flow.push(section)
      }
      WizardManager.ChildWizard.stateData = this.rewardInfo
      WizardManager.stateData = payload
      WizardManager.ChildWizard.currentFlowIndex = WizardManager.ChildWizard.flow.length - 1
      localStorage.setItem('wizardManager', JSON.stringify(WizardManager))
    }
  }
}
</script>
